export const SurveyRoutes = {
    ROOT: "/survey",
    SIGNING: "/survey/signing",
    SUCCESS: "/survey/success",
    NEW_PHONE: "/survey/new-phone",
    NEW_ADDRESS: "/survey/new-address",
    ERROR_EXPIRED: "/survey/error-expired"
};



// WEBPACK FOOTER //
// ./src/components/survey/SurveyRoutes.tsx